import { Alert, AlertIcon, Flex, Spinner } from '@chakra-ui/react';
import { ReactNode, useEffect, useState } from 'react';

// Charge les données d'une liste : indicateur pendant le chargement, message si la lecture échoue
export default function ListLoader<T>(props: { load: () => Promise<T[] | null>; children: (data: T[]) => ReactNode }) {
	const { load, children } = props;
	const [ data, setData ] = useState<T[] | null>(null);
	const [ loadError, setLoadError ] = useState(false);

	useEffect(() => {
		let cancelled = false;
		const fetchData = async () => {
			try {
				const rows = await load();
				if (!cancelled) {
					setData(rows || []);
				}
			} catch (error) {
				console.error('Erreur lors du chargement de la liste :', error);
				if (!cancelled) {
					setLoadError(true);
				}
			}
		};
		fetchData();
		return () => {
			cancelled = true;
		};
	}, [ load ]);

	if (loadError) {
		return (
			<Alert status='error' borderRadius='md'>
				<AlertIcon />
				Impossible de charger la liste. Rechargez la page.
			</Alert>
		);
	}
	if (!data) {
		return (
			<Flex minH='50vh' align='center' justify='center'>
				<Spinner size='xl' />
			</Flex>
		);
	}
	return <>{children(data)}</>;
}
